import { IconContext } from 'react-icons';
import { FiMail } from 'react-icons/fi';
import { TfiLocationPin } from 'react-icons/tfi';
import './contact.css';

const Contact = () => {
	const handleFormSubmit = (e) => {
		e.preventDefault();
	};
	return (
		<IconContext.Provider value={{ className: 'contact-icon' }}>
			<div className='contact'>
				<div className='contact-bg'></div>
				<div className='contact-wrapper'>
					<div className='contact-left'>
						<h1 className='contact-title'>Let's discuss your project</h1>
						<div className='contact-information'>
							<div className='contact-information-item'>
								<FiMail /> ndimaret@gmail.com
							</div>
							<div className='contact-information-item'>
								<TfiLocationPin /> Bernau bei Berlin, Germany.
							</div>
						</div>
					</div>
					<div className='contact-right'>
						<p className='contact-description'>
							<b>Thank you for your Interest ❤️.</b> &nbsp;This is a dummy Form
							created just for demonstration purposes.
						</p>
						<form onSubmit={handleFormSubmit}>
							<input
								className='contact-input'
								type='text'
								placeholder='Name'
								name='user_name'
							/>
							<input
								className='contact-input'
								type='text'
								placeholder='Subject'
								name='user_subject'
							/>
							<input
								className='contact-input'
								type='text'
								placeholder='Email'
								name='user_email'
							/>
							<textarea
								className='contact-textarea'
								name='message'
								placeholder='Message'
								rows='5'
							></textarea>
							<button className='contact-button'>Submit</button>
						</form>
					</div>
				</div>
			</div>
		</IconContext.Provider>
	);
};

export default Contact;
